module.exports = __webpack_public_path__ + "img/ic-layouts-inactive.68dc14eb.svg";